import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

const MessagesFindInputsSchema = z.object({
  'contact-id': z
    .string()
    .describe('The ID of the contact whose messages to find'),
  'communication-channel-id': z
    .string()
    .optional()
    .describe('Optional communication channel to filter messages by'),
  limit: z
    .number()
    .optional()
    .default(10)
    .describe('Max number of messages to return'),
})

const MessagesFindOptionsSchema = z.object({})

export const MessagesFindCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/conversations'),
    cmd: z.literal('messages.find'),
    options: MessagesFindOptionsSchema.optional(),
  }),
  inputs: MessagesFindInputsSchema,
})

export type MessagesFindCommand = z.infer<typeof MessagesFindCommandSchema>
